export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "localZones.worker.a67eabc9b7dc44e847a0.worker.js");
}
